import React from 'react'
import Layout from '../../../components/common/pageLayout'
import Form from '../../../components/MasterData/LeaveType/add'
import { v3_add_leaveType } from '../../../actions/v3/masterData'
import constant from '../../../constant'
import { toast } from 'react-toastify'
const Add = (props) => {

    const onSubmit = (model) => {
        v3_add_leaveType(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listLeaveTypeMasterData.url)
            }
            else {
                toast.error(res.error)

            }
        })
    }
    return (
        <React.Fragment>
            <Layout
                title={'Master Data'}
            >
                <Form
                    title={'Add Leave Type'}
                    onSubmit={onSubmit}
                    buttonName={'Create Leave Type'}
                />
            </Layout>
        </React.Fragment>
    )
}

export default Add